import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BookingStatus } from 'src/app/constants/global-constants';
import { IDashboardMumPayload, IMumsBooking } from 'src/app/models/dashboard.models';
import { ViewBookingComponent } from 'src/app/pages/shared-components/view-booking/view-booking.component';
import { DashboardService } from 'src/app/services/dashboard.service';
declare var $: any;
@Component({
  selector: 'app-booked-midwifes',
  templateUrl: './booked-midwifes.component.html',
  styleUrls: ['./booked-midwifes.component.scss']
})
export class BookedMidwifesComponent implements OnInit {

  @Input() dashboard: IDashboardMumPayload;
  booking: IMumsBooking;
  bookingStatus = BookingStatus;
  status: string;
  @ViewChild(ViewBookingComponent) bookingModal: ViewBookingComponent;

  constructor(public dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.booking = this.dashboard.mumsBooking
    if(new Date(this.booking.endDate) < new Date())
    {
      this.status = this.bookingStatus.COMPLETED;
    }
    else
    {
      this.status = this.bookingStatus.NOT_COMPLETED;
    }
  }

  viewDetail(){
    this.bookingModal.bookingDetailMum = this.booking;
    this.bookingModal.generateBookingDatesMum(this.dashboard.dueDate);
    $('#booking-details-mum').modal('show');
  }
}
